<div class="occupancy-report-wrapper">
  <h2>Beläggningsrapport</h2>

  <!-- Datepicker -->
  <div class="filters">
    <div class="date-and-export">
      <mat-form-field>
        <mat-label>Välj period</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate name="from" [formControl]="from" placeholder="Startdatum" />
          <input matEndDate name="to" [formControl]="to" placeholder="Slutdatum" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button (click)="downloadReportBookings()" class="button slim secondary export"
        title="Exportera till CSV">Exportera<mat-icon>save_alt</mat-icon>
      </button>
    </div>

    <!-- Resource toggle -->
    <div>
      <mat-button-toggle-group *ngIf="resources.length" #group="matButtonToggleGroup"
        value="{{resources[0].resourceId}}" (change)="changeResourceType(group.value)">
        <mat-button-toggle *ngFor="let resource of resources" value="{{resource.resourceId}}"
          name="resource">{{resource.label}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <!-- Chart -->
  <div class="info-icon">
    <mat-icon>info</mat-icon>
    <div class="show-on-info-icon-hover">
      <h4>{{getResourceLabel()}}</h4>
      <p><strong>Ankommande</strong> – de bilar som landar på Arlanda, dvs. som ska hämta bilen och åka ifrån
        parkeringen.</p>
      <p><strong>Avgående</strong> – de bilar som ska ut och resa, dvs. de bilar som kommer och startar sin parkering.
      </p>
    </div>
  </div>

  <div *ngIf="!loading && chartData.length > 0" class="chart">
    <app-stat-linechart [titleArray]="chartTitles" [chartData]="chartData" [showTooltip]="true"></app-stat-linechart>
  </div>

  <!-- Table -->
  <div class="table" *ngIf="occupancyReports.length > 0 && !loading">
    <table mat-table [dataSource]="occupancyReports">
      <!-- Main header group for resources -->
      <ng-container *ngFor="let label of getResourceLabels()" matColumnDef="{{label}}">
        <ng-container *ngIf="label != 'empty-header'">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="main-header">{{label}}</th>
        </ng-container>
        <ng-container *ngIf="label === 'empty-header'">
          <th mat-header-cell *matHeaderCellDef class="main-header"></th>
        </ng-container>
      </ng-container>

      <!-- Header group -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Datum</th>
        <td mat-cell *matCellDef="let report">{{report.date | date: 'yyyy-MM-dd EEEE'}}</td>
      </ng-container>

      <ng-container *ngFor="let resource of resources">
        <!-- Arriving outside -->
        <ng-container matColumnDef="{{'arriving-' + resource.name}}">
          <th mat-header-cell *matHeaderCellDef class="number-data">Ankommande bilar</th>
          <td mat-cell *matCellDef="let report" class="number-data">
            {{report.allocations[resource?.resourceId || 0]?.arrivalQty}}
          </td>
        </ng-container>

        <!-- Departing outside -->
        <ng-container matColumnDef="{{'departing-' + resource.name}}">
          <th mat-header-cell *matHeaderCellDef class="number-data">Avresande bilar</th>
          <td mat-cell *matCellDef="let report" class="number-data">
            {{report.allocations[resource?.resourceId || 0]?.departureQty}}
          </td>
        </ng-container>

        <!-- Filled spots outside -->
        <ng-container matColumnDef="{{'filled-' + resource.name}}">
          <th mat-header-cell *matHeaderCellDef class="number-data filled-column">Fyllda platser</th>
          <td mat-cell *matCellDef="let report" class="number-data filled-column">
            {{report.allocations[resource?.resourceId || 0]?.occupiedQty}}
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="getResourceLabels()"></tr>
      <tr mat-header-row *matHeaderRowDef="getColumnDefinitions()">
      </tr>
      <tr mat-row *matRowDef="let rowData; columns: getColumnDefinitions()">
      </tr>
    </table>
  </div>

  <!-- Spinner -->
  <div class="spinner">
    <mat-spinner *ngIf="loading"></mat-spinner>
  </div>

  <!-- No data warning -->
  <div *ngIf=" !occupancyReports.length && !loading" class="{{!errorMessage ? 'empty-content' : 'error-content'}}">
    <p>{{errorMessage ? 'Någonting gick fel, kunde inte hämta data för den valda perioden.' :
      'Det finns inga data för den valda perioden.'}}</p>
  </div>
</div>